import { useEffect, useState } from "react";
import MainLayout from "../../layout/MainLayout";
import { Button2, Select, ToggleButton, QuickActionSelect } from "../index";

import RequestMoneyCreate from "./RequestMoneyCreate";
import RequestMoneyActive from "./RequestMoneyActive";
import { useAccounts } from "../../data/live";

const last4 = (s) => (s ? String(s).slice(-4) : "0000");

const RequestMoney = ({ initialTab = "Active" }) => {
  const { accounts } = useAccounts();

  const [tab, setTab] = useState(initialTab);
  const [sourceAccountId, setSourceAccountId] = useState("");

  useEffect(() => {
    if (accounts.length > 0 && !sourceAccountId) {
      const def = accounts.find((a) => a.isDefault) || accounts[0];
      setSourceAccountId(def.id);
    }
  }, [accounts, sourceAccountId]);

  const sourceAccount = accounts.find((a) => a.id === sourceAccountId);

  const accountOptions = accounts.map((a) => ({
    name: `${a.currency} • ****${last4(a.accountNumber || a.iban)}${
      a.isDefault ? " (Default)" : ""
    }`,
    value: a.id,
  }));

  const renderTab = () => {
    switch (tab) {
      case "Active":
        return <RequestMoneyActive />;
      case "Create":
        return <RequestMoneyCreate sourceAccount={sourceAccount} />;
      default:
        return <RequestMoneyActive />;
    }
  };

  return (
    <MainLayout
      expand={false}
      NavName="Request Money"
      navbarChildren={tab === "Active" && <QuickActionSelect />}
    >
      <div>
        <div className="container mt-5">
          <div className="d-flex flex-column gap-3">
            {tab === "Create" && (
              <Select
                value={sourceAccountId}
                onChange={(e) => setSourceAccountId(e.target.value)}
                options={accountOptions}
                defaultValue="Select account"
                selectStyle={{ width: "22%" }}
                className="bg-light rounded-5"
                popupClassName="bg-White"
              />
            )}
            <div className="d-flex justify-content-between align-items-center">
              <ToggleButton
                options={["Active", "Inactive", "Create"]}
                defaultValue={tab}
                onChange={(value) => setTab(value)}
              />
              {tab === "Active" ? (
                <Button2
                  buttonName={"Request Payment"}
                  className={"btn-dark"}
                  onClick={() => setTab("Create")}
                />
              ) : (
                <QuickActionSelect />
              )}
            </div>
          </div>

          {renderTab()}
        </div>
      </div>
    </MainLayout>
  );
};

export default RequestMoney;
